export default {"src":"/_next/static/media/how-to-use-it.colour.ea3d64f4.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};